import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import cookie from 'js-cookie';
import { assignToken } from '../features/token/token';

const buildAuthToken = () => {
  const clientname = import.meta.env.VITE_APP_CLIENT;
  const instance = import.meta.env.VITE_APP_INSTANCE;
  return btoa(`Basic ${clientname}:${instance}`);
};

const readTokenFromCookie = () => {
  try {
    const cookieVal = cookie.get('token');
    return cookieVal ? JSON.parse(cookieVal).value : null;
  } catch (e) {
    return null;
  }
};

const loginFn = async (accessCode = null) => {
  const headers = {
    Authorization: buildAuthToken(),
    'Content-Type': 'application/json',
  };
  if (accessCode) {
    headers['Access-Code'] = accessCode;
  }

  const response = await axios.get(
    `${import.meta.env.VITE_API_URL}api/login`,
    { headers },
  );
  return response.data;
};

export function useLogin() {
  const [token, setToken] = useState(readTokenFromCookie);
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: loginFn,
    onSuccess: (data) => {
      if (data.token) {
        cookie.set('token', JSON.stringify({ value: data.token }), { secure: true });
        setToken(data.token);
        dispatch(assignToken(data.token));
      }
    },
  });

  return {
    loginAsync: mutation.mutateAsync,
    token,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    data: mutation.data,
  };
}
